import { z } from 'zod'

export const BelongStatus = z.enum([
  'DAMAGED',
  'LOST',
  'ERROR',
  'PENDING_RETURN',
  'RETURNED',
  'READY_TO_USE',
  'PENDING'
])
export type BelongStatus = z.infer<typeof BelongStatus>
